import React, { useState } from 'react';
import { Spinner } from '../../root/components/Spinner';
import styles from './CartCTA.module.scss';
import useSafariBfCacheInvalidator from '../../hooks/useSafariBfCacheInvalidator';
import { Icon } from '../../icons/Icon';
import classNames from 'classnames';

interface Props {
  hasLineItems: boolean;
  token: string | undefined;
}

export const CartCTA: React.FC<Props> = ({ hasLineItems, token }) => {
  const [loading, setLoading] = useState<boolean>(false);
  useSafariBfCacheInvalidator(setLoading);
  const preSubmit = () => {
    setLoading(true);
  };

  return (
    <div className={classNames(styles.hlCartCtaBar, { [styles.loading]: loading })}>
      <form action="/cart" method="post" noValidate={true} className={styles.cartForm} onSubmit={preSubmit}>
        <button type="submit" name="checkout" className="checkout__button" disabled={!hasLineItems}>
          <Spinner visible={loading} light={true} forButton={true} styleOverrides={{ spinner: { opacity: '0.5', left: 'calc(50% - 20px)' } }} />
          {loading ? (
            ''
          ) : (
            <>
              <span>Checkout</span>
              <Icon name="lock" style={{ width: '12px', marginLeft: '8px', marginBottom: '-1px' }} />
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default CartCTA;
